import { Anchor, Stack, Title, Button } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import './CustomCard.scss';
// @ts-expect-error react-intercom package is not typed
import { IntercomAPI } from 'react-intercom';
import { SUPPORT_EMAIL } from '../../../../../../config/email-addresses';
import openEmailClient from '../../../../../../services/openEmailClient';

const CustomCard = () => (
	<Stack className="CustomCard" justify="space-between">
		<Stack spacing="20px">
			<Title order={2}>Custom</Title>
			<Text variant="body-bold" color="dark.3">Need something different?</Text>
			<Text variant="body" color="dark.3">Request a tailored proposal for you and your team.</Text>
			<Anchor color="blue.5" onClick={() => openEmailClient( SUPPORT_EMAIL )}>
				<Text variant="body">{SUPPORT_EMAIL}</Text>
			</Anchor>
		</Stack>
		<Button size="large" fullWidth onClick={() => IntercomAPI( 'show' )}>
			Contact us
		</Button>
	</Stack>
);

export default CustomCard;
